/**
 *
 * @param {boolean} isBreadcrumb Are the facets related to a breadcrumb click?
 * @param {boolean} checked Is the element checked that was clicked to get here?
 * @param {object} facets The current facets selected on the page.
 * @param {string} name The name of the facet related to the clicked breadcrumb.
 * @param {string} value The value of the facet related to the clicked breadcrumb.
 * @description The reason for this being broken out into a function is so that we can more easily unit test it.
 * We can't find any sites that have HTML set up that allows the logic in this function to even run.
 *
 * It appears the goal here is to update the facet state based on the removal via breadcrumb click. So if Audi, BMW, Toyota are selected
 * and Toyota is removed then the resulting facets should just have make of Audi, BMW.
 */
const getFacetsForBreadcrumbs = (
	isBreadcrumb,
	checked,
	facets,
	name,
	value
) => {
	const facetsCopy = JSON.parse(JSON.stringify(facets));
	if (isBreadcrumb && !checked && facets[name]) {
		// delete facet entry if unchecked
		const valArr = facets[name].split(',');
		const valIndex = valArr.indexOf(value);

		if (valIndex > -1) {
			valArr.splice(valIndex, 1);
		}

		if (valArr.length > 0) {
			facetsCopy[name] = valArr.join();
		} else {
			delete facetsCopy[name];
		}
	}

	return facetsCopy;
};

export default getFacetsForBreadcrumbs;
